import { CreateResearchDialog } from "@/components/DocumentCreate/CreateResearchDialog";
import { ARTIFACT_DEFAULT_ICON } from "@/components/display/display-name/defaults";
import { LibraryModal } from "@/components/file/LibraryFileDialog";
import { LinkDriveFolderDialog } from "@/components/folder/LinkDriveFolderDialog";
import { useMatchRoute } from "@tanstack/react-router";
import { useState } from "react";
import { KitMenuTemplate } from "../KitMenuTemplate";
import {
  SETTINGS_GROUP_PARTIAL,
  useDocumentGroup,
  useFolderGroup,
  useLibraryGroup,
} from "./hooks";
import { KitTypeMenuProps } from "./types";

export const ProjectMenu: React.FC<KitTypeMenuProps> = ({
  mode,
  groupUuid,
  groupSlug,
  kit,
}) => {
  const matchRoute = useMatchRoute();
  const [researchDialog, setResearchDialog] = useState(false);
  const [driveFolderDialog, setDriveFolderDialog] = useState(false);
  const [libraryOpen, setLibraryOpen] = useState(false);
  const documentGroup = useDocumentGroup({
    groupUuid,
    groupSlug,
    kitUuid: kit.uuid,
    onCreateResearchClick: () => setResearchDialog(true),
  });
  const folderGroup = useFolderGroup({
    groupUuid,
    kitUuid: kit.uuid,
    onLinkDriveFolderClick: () => setDriveFolderDialog(true),
  });
  const libraryGroup = useLibraryGroup({
    onOpen: () => setLibraryOpen(true),
  });

  const groups = [
    documentGroup,
    folderGroup,
    libraryGroup,
    {
      title: "Artifacts",
      icon: ARTIFACT_DEFAULT_ICON,
      active: !!matchRoute({
        to: "/w/$groupSlug/k/$kitUuid/artifacts",
        params: { groupSlug, kitUuid: kit.uuid },
        fuzzy: true,
      }),
      link: {
        to: "/w/$groupSlug/k/$kitUuid/artifacts" as const,
        params: { groupSlug, kitUuid: kit.uuid },
      },
    },
    {
      ...SETTINGS_GROUP_PARTIAL,
      active: !!matchRoute({
        to: "/w/$groupSlug/k/$kitUuid/workbook-settings",
        params: { groupSlug, kitUuid: kit.uuid },
        fuzzy: true,
      }),
      link: {
        to: "/w/$groupSlug/k/$kitUuid/workbook-settings" as const,
        params: { groupSlug, kitUuid: kit.uuid },
      },
    },
  ];
  return (
    <>
      <KitMenuTemplate kit={kit} groups={groups} mode={mode} />
      <CreateResearchDialog
        open={researchDialog}
        onOpenChange={() => setResearchDialog(false)}
      />
      <LinkDriveFolderDialog
        open={driveFolderDialog}
        onOpenChange={setDriveFolderDialog}
        groupUuid={groupUuid}
        groupSlug={groupSlug}
        kitUuid={kit.uuid}
      />
      <LibraryModal
        open={libraryOpen}
        onOpenChange={setLibraryOpen}
        groupUuid={groupUuid}
        kitUuid={kit.uuid}
      />
    </>
  );
};
